import { FrameInfo } from './frameInfo/frameInfo'

//用紙
export class Paper{
    id : number = 0; //Db上のID
    name : string = "";
    code : string = ""; //用紙品番("51979-12P"とか)
    formatCode : string = ""; //フォーマット番号
    surface : number = 0; //面の数(表も裏もあれば2など)
    frameNumber : number = 0; //1ページ毎のデザイン(ラベル)の枚数
    imagePath : string = ""; //一面のプレビュー画像(フレームの配置とかが分かる)
    splitProductCode : string = ""; //切り離し元親商品コード 多分、("51979-12P"の、"51979"の部分)
    width : number = 0; //用紙の横幅
    height : number = 0; //用紙の縦幅
    direction : string = ""; //向き どうやら使っていない
    typeName : string = ""; //用紙のタイプの名前(A4判など)
    description : string = ""
    frameInfoList : FrameInfo[] = [ new FrameInfo() ]; //用紙のフレームの情報
    defaultTemplateCategoryId : number = 0
    defaultTemplateHierarchy : number = 0
}